<template>
	<div class="login-container">
		<div class="back-box">
			<div class="con-div">
				<div class="con-name"> 商户后台管理系统</div>
				<div class="login-box">
					<div class="login-content">
						<span>欢迎登陆</span>
					</div>
					<div class="login-input-box">
						<div class="login-input-div">
							<div class="input-icon"><span class="iconfont">&#xe602;</span></div>							
							<el-input size="medium" class="login-input" placeholder="请输入用户名" v-model="username" clearable></el-input>
						</div>
						<div class="login-input-div">
							<div class="input-icon"><span class="iconfont">&#xe625;</span></div>							
							<el-input size="medium" type="password" class="login-input" placeholder="请输入密码" v-model="password" show-password></el-input>
						</div>
						
						<div class="login-input-div code-input-div">
							<div class="input-icon"><span class="iconfont">&#xe7ab;</span></div>							
							<el-input size="medium" class="code-input login-input" placeholder="请输入验证码" v-model="code"></el-input>
							<div class="code-img-div" @click="getCaptcha"><img :src="qrCodeUrl"/></div>
						</div>
						<div class="forget-pwd-div"> <el-link type="primary" class="forget-pwd" @click="forgetPwd">忘记密码</el-link></div>
					
					</div>

					<div class="login-btn"><el-button @click="login()" size="medium" class="" type="primary" style="width: 100%;" :disabled="loading">登 录</el-button></div>
					
				</div>
			</div>
			
		</div>
		<div class="dialog-div">
			<el-dialog center custom-class="forget-dialog-class" :top="dialog.top" width="30.5%" title="" :visible.sync="dialog.visible"  @close="close" :close-on-click-modal="false" :show-close="true">
				<div class="dialog-content">
					<div class="dialog-title">邮箱地址:</div>
					<div class="dialog-email-div"><input size="small" class="email-input" type="email" v-model="dialog.email" placeholder="请输入系统登录邮箱地址"/></div>
					<div class="dialog-tip">{{this.dialog.error}}</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button class="dialog-btn" type="primary" size="mini" @click="sureSend" :disabled="dialog.loading">确定，发送邮件</el-button>
				</div>                           
			</el-dialog>
			
		</div>
	</div>
</template>

<script>
	// import QRCode from 'qrcodejs2'
	// import local from '@/util/local'
	import axios from 'axios'
	import {
		isEmpty,
		isPositiveNumber,
		isMoney
	} from '@/util/validate'
	import {
		Message
	} from 'element-ui'
	export default {
		name: 'Login',
		data() {
			return {
				username:'',
				password:'',
				code:'',				
				loading:false,
				qrCodeBaseUrl:`${this.$baseURL}/login/getCaptcha`,
				qrCodeUrl:'',
				dialog:{
					top: "15vh",
					visible:false,
					email:'',
					loading:false,
					error:'',
				}
			}
		},
		created() {
			this.getCaptcha()
		},
		mounted(){
			let self = this
			document.onkeydown = function(e) {
			  let ev = document.all ? window.event : e
			  if (ev.keyCode === 13) {
				  if(!self.loading){
					  self.login()
				  }
				
			  }
			}
		},
		destroyed() {
			document.onkeydown = null
		},
		watch: {},
		methods: {
			 //计算窗口位置
			 getDialogTop(className){
                this.$nextTick(() => {			
                    let documentHeight = document.documentElement.clientHeight
                    let dialogdiv =  document.getElementsByClassName(className)[0].offsetHeight
                    this.dialog.top =( documentHeight - dialogdiv) / 2 +'px'
                    // console.log(documentHeight,'===',dialogdiv,'===',this.dialog.top)
                })
            },
			//获取验证码图片
			async getCaptcha(){
				// 在 URL 后面加上时间戳，防止浏览器缓存
				try {
					const response = await axios.get(`${this.$baseURL}/login/getCaptcha`, {	responseType: "blob",	withCredentials: true });// 允许携带 cookie					
					this.qrCodeUrl = URL.createObjectURL(response.data);
				} catch (error) {
					console.error("验证码获取失败", error);
				}

			},
			login(){
				if(isEmpty(this.username,"请输入账号")){
					return
				}
				if(isEmpty(this.password,"请输入密码")){
					return
				}
				if(isEmpty(this.code,"请输入验证码")){
					return
				}
				let data={
					username:this.username,
					password:this.$md5(this.password),
					code:this.code,
				}
				this.loading = true
				
				

				// this.$local.set('username','aba');
				// this.$local.set('tid','txpecmwkqtomsxpiqqkvzbrflpjhqjsz');						
				// this.$router.push('./dashboard')


				this.$api.dologin(data).then(res => {
					this.loading = false
					
					if(res.status === 1){
						let data = res.data	
						this.$local.set('username',data.username);
						this.$local.set('tid',data.tid);	
						this.$local.set('is_first_login',data.is_first_login)					
						this.$router.push('./cardPwdManage')
						this.$parent.username = data.username
					}else if(res.status === 4){//验证码错误 重新获取验证码
						this.getCaptcha()
						this.$message({
						  type: 'error',
						  message: res.msg
						}); 
					}else{
						this.$message({
						  type: 'error',
						  message: res.msg
						}); 
					}
				}).catch(error=>{
					this.loading = false
				})
			},
			//忘记密码  打开邮箱弹窗
			forgetPwd(){
				this.dialog.visible = true;
				this.getDialogTop("forget-dialog-class")
			},
			//关闭邮箱弹窗
			close(){
				this.dialog.visible = false;
			},
			sureSend(){
				//验证邮箱
				if(this.dialog.email.trim() == ""){
					this.dialog.error = "提示：请输入邮箱地址"
					return
				}
				if(!this.validateEmail(this.dialog.email)){
					this.dialog.error = "提示：邮箱格式不正确，请填写正确的邮箱"
					return
				}
				this.recoverPwd()
				
			},
			//提交邮箱接口
			recoverPwd(){
				let data = {
					user:this.dialog.email
				}
				this.dialog.loading = true;
				this.$api.recoverPwd(data).then(res=>{
					this.dialog.loading = false;
					if(res.status == 1){
						this.dialog.visible = false;
						this.$alert('<div class="login-email-success"><div class="email-success">重置密码邮件已发送，请前往邮箱：'+this.dialog.email+'进行重置密码</div><div class="success-tip">邮件有效时间：2小时</div></div>', 
							'',
							 {
								dangerouslyUseHTMLString: true,
								customClass:'login-email-alert'
							}
						);
					}else{
						this.dialog.error = res.msg
						// Message({
						// 	message: res.msg,
						// 	type: 'error',
						// 	duration: 3 * 1000
						// })
					}
				}).catch(e=>{
					this.dialog.loading = false;
				})
			},
			//验证邮箱
			validateEmail(email) {
				const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				return re.test(email);
				
			}
		}
	}
</script>
<style lang="scss" >
	.login-input{
		width: 100%;
		input{
			padding-left: 32px !important;
		}
	}
	.login-email-alert{
		.el-message-box__btns{
			text-align: center  !important;
			.el-button{
				
				width: 130px;
				height: 30px;
				border-radius: 16px;
			}
		}
		.login-email-success{
			font-size: 16px;
			.email-success{
				margin-top: 10px;
			}
			.success-tip{
				color:#be4747;
				font-size: 14px;
			}
		}
	}
	
</style>
<style lang="scss" scoped>
	.login-container {
		
		background: #006EFF;
		background-size: cover;
		.back-box{
			height: 100vh;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			.con-div{
				margin-bottom: 100px;
				border-radius: 12px;
				width: 440px;
				.con-name{
					color: #fff;
					margin-bottom: 55px;
					font-size: 48px;
					text-align: center;
				}
				.login-box{
					border-radius: 4px;
					background-color: #fff;
					padding: 30px 30px 60px;
					width: 440px;
					height: 460px;	
					box-sizing: border-box;
					.login-content{
						text-align: center;
						font-size:32px;
						color:#333333;
						margin-bottom:56px;
					}
					.login-input-box{
						margin-bottom:48px;
						// display: flex;
						// flex-direction: column;
						// justify-content:space-between;
						// align-items: flex-start;
						.login-input-div{
							width: 100%;
							position: relative;
							margin-bottom: 25px;
							.input-icon{
								position: absolute;
								left:0;
								top:0;
								// transform:translate(0,-50%)
								width:32px;
								height:100%;
								display: flex;
								justify-content:center;
								align-items: center;
								z-index:1;
								color: #808695;
							}
							.login-input{
								width: 100%;
							}
							&.code-input-div{
								display: flex;
								.code-img-div{
									width: 110px;
									margin-left: 10px;
									border: solid 1px #DCDEE2;
									img{
										width: 100%;
										height: 100%;
									}
								}
							}
							
						}
						.forget-pwd-div{
							text-align: right;
							margin-top: 18px;
							.forget-pwd{
								font-size: 14px;
								color: #2d8cf0;
							}
							
						}
					}
					.login-btn{

					}

				}
			}
		}
		.dialog-div{
			.dialog-content{
				.dialog-title{
					font-size: 20px;
					color:#101010;
				}
				.dialog-email-div{
					margin-top: 14px;
					.email-input{
						width: 100%;
						height: 30px;
						padding: 0 10px;
						border:1px solid #bbb;
						outline: none;
					}
				}
				.dialog-tip{
					margin-top: 14px;
					color:#be4747;
					font-size: 14px;
				}
			}
			.dialog-btn{
				width: 130px;
				height: 30px;
				border-radius: 16px;
			}
		}
		
		
		
	}
	
</style>
